export default [
  { id: 2, title: 'Unbekannt', is_default: true },
  { id: 0, title: 'Regelbesteuerung', is_default: false },
  { id: 1, title: 'Kleinunternehmerregelung', is_default: false },
];
